import React from 'react';
import {
  useInfiniteQuery,
  useQuery,
  useQueryClient,
  useMutation,
} from '@tanstack/react-query';
import { Divider } from '@nextui-org/react';
import Comment from '../Comment/Comment';
import Loading from '../Loading/Loading';
import { getCommentById, addCommentForComment } from '../../services/querys ';
import { message } from 'antd';

function CommentSection({ postId }) {
  const {
    isLoading,
    data = [],
    error,
  } = useQuery({
    queryKey: [`comment/${postId}`],
    queryFn: () => getCommentById(postId),
    enabled: !!postId,
    refetchOnWindowFocus: false,
  });

  const queryClient = useQueryClient();

  const handleAddReply = (parentId, commentText, file, postId) => {
    if (!parentId) {
      message.error('You can not reply');
      return;
    }
    addCommentMutation({ postId, parentId, commentText, file });
  };

  const { mutate: addCommentMutation, isLoading: isAddingComment } =
    useMutation({
      mutationFn: addCommentForComment,
      onError: (error) => {
        console.error('Error adding comment:', error);
        message.error(error?.response?.data?.error || error.message);
      },
      onSuccess: async () => {
        message.success('Comment added successfully');
        await queryClient.invalidateQueries(['posts']);
      },
    });

  const organizeComments = (comments) => {
    const commentMap = {};

    comments.forEach((comment) => {
      commentMap[comment.commentId] = { ...comment, replies: [] };
    });

    const topLevelComments = [];

    comments.forEach((comment) => {
      if (comment.parentId) {
        const parent = commentMap[comment.parentId];
        if (parent) {
          parent.replies.push(commentMap[comment.commentId]);
        }
      } else {
        topLevelComments.push(commentMap[comment.commentId]);
      }
    });

    return topLevelComments;
  };

  const comments = organizeComments(data);

  return (
    <>
      <Loading isLoading={isLoading} />
      {data?.length > 0 && (
        <>
          <h3 className="text-gray-300 text-md p-5">{data?.length} Comments</h3>
          <Divider className="px-4 bg-gray-600 justify-center mb-5" />
        </>
      )}
      {comments?.map((comment) => (
        <React.Fragment key={comment?._id}>
          <Comment comment={comment} level={0} onReply={handleAddReply} />
        </React.Fragment>
      ))}
    </>
  );
}

export default CommentSection;
